import { motion, useScroll, useTransform } from "framer-motion";
import { fadeUp, PrimaryCTA, SecondaryCTA } from "./shared";

export const Hero = () => {
    const { scrollY } = useScroll();
    const y = useTransform(scrollY, [0, 600], [0, 120]);

    return (
        <section
            id="hero"
            data-testid="hero-section"
            className="relative min-h-screen w-full overflow-hidden bg-[#0A0A0A]"
        >
            <motion.div style={{ y }} className="absolute inset-0" aria-hidden>
                <img
                    src="/images/hero.png"
                    alt="Napelemes családi ház keresztmetszete gépészeti, villamos és fűtési rendszerekkel"
                    loading="eager"
                    fetchpriority="high"
                    decoding="async"
                    className="w-full h-full object-cover object-[52%_center] sm:object-[70%_center]"
                />
            </motion.div>
            <div className="absolute inset-0 hero-overlay" />

            <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 pt-28 sm:pt-40 pb-56 sm:pb-40 min-h-screen flex flex-col">
                <motion.div
                    variants={fadeUp}
                    initial="hidden"
                    animate="show"
                    className="flex items-center gap-4 text-white/80"
                >
                    <span className="h-px w-10 bg-white/30" />
                    <span className="font-mono-label text-xs text-[#7ED4CE]">
                        Gépészet · Felújítás · Napelem · Villany
                    </span>
                </motion.div>

                <div className="max-w-4xl mt-10 sm:mt-24">
                    <motion.h1
                        variants={fadeUp}
                        custom={1}
                        initial="hidden"
                        animate="show"
                        className="font-display-alt font-extrabold text-white text-[3.5rem] sm:text-7xl lg:text-8xl leading-[0.95]"
                        data-testid="hero-headline"
                    >
                        Energia.
                        <br />
                        Precizitás.
                        <br />
                        <span className="text-[#7ED4CE]">Stabilitás.</span>
                    </motion.h1>

                    <motion.div
                        variants={fadeUp}
                        custom={3}
                        initial="hidden"
                        animate="show"
                        className="mt-10 flex flex-wrap items-center gap-4"
                    >
                        <PrimaryCTA testId="hero-cta-primary" href="#kapcsolat">
                            Ajánlatot kérek
                        </PrimaryCTA>
                        <SecondaryCTA testId="hero-cta-secondary" href="#szolgaltatasok" light>
                            Szolgáltatásaink
                        </SecondaryCTA>
                    </motion.div>
                </div>
            </div>

            {/* Full-width bottom stats bar */}
            <motion.div
                variants={fadeUp}
                custom={4}
                initial="hidden"
                animate="show"
                className="hero_stats absolute bottom-0 left-0 right-0 z-10 border-t border-white/15 backdrop-blur-sm"
            >
                <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-6 sm:py-8 grid grid-cols-2 sm:grid-cols-4 gap-6 sm:gap-12">
                    {[
                        { k: "20+", v: "év tapasztalat" },
                        { k: "500+", v: "elvégzett munka" },
                        { k: "100%", v: "garanciális munka" },
                        { k: "0 Ft", v: "konzultációs díj" },
                    ].map((s) => (
                        <div key={s.v} className="text-white text-center">
                            <div className="font-display font-extrabold text-3xl sm:text-4xl text-[#7ED4CE] tabular">
                                {s.k}
                            </div>
                            <div className="mt-1 text-white/70 text-xs sm:text-sm font-mono-label">
                                {s.v}
                            </div>
                        </div>
                    ))}
                </div>
            </motion.div>
        </section>
    );
};
